const data = [
  {
    id: "payments",
    icon: "iconsminds-credit-card",
    label: "Payments",
    to: `/app/payments`,
    access: ["Admin", "Manager", "Supervisor", "User"],
  },
  // {
  //   id: "smartup-bulk-import",
  //   icon: "iconsminds-calendar-4",
  //   label: "Smartup Bulk Import",
  //   to: `/app/smartup-bulk-import`,
  //   access: ["Admin", "Manager", "Supervisor"],
  // },
  {
    id: "pins",
    icon: "iconsminds-data-center",
    label: "PINPP List",
    to: `/app/pins`,
    access: ["Admin", "Manager", "Supervisor", "User"],
  },
  {
    id: "checkpin",
    icon: "iconsminds-magnifi-glass",
    label: "Check Pin",
    to: `/app/checkpin`,
    access: ["Admin", "Manager", "Supervisor", "User"],
  },
  {
    id: "pos",
    icon: "iconsminds-cash-register-2",
    label: "POS Terminal",
    to: `/app/pos`,
    // Gated by a per-user flag, not a role: only accounts with POS access
    // switched on see this at all.
    requires: "posAccess",
  },
  {
    id: "smartup-sync",
    icon: "iconsminds-sync",
    label: "Smartup Sync",
    to: `/app/smartup-sync`,
    access: ["Admin"],
  },
  {
    id: "promocode-requests",
    icon: "iconsminds-check",
    label: "Promocode Requests",
    to: `/app/promocode-requests`,
    access: ["Admin"],
  },
  {
    id: "users",
    icon: "iconsminds-administrator",
    label: "Users",
    to: `/app/users`,
    access: ["Admin"],
  },
  {
    id: "promocodes",
    icon: "iconsminds-tag",
    label: "Promocodes",
    to: `/app/promocodes`,
    access: ["Admin"],
  },
];
export default data;
